module.exports = __webpack_public_path__ + "img/ico_usuario-35.d441aa6f.svg";